import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import type { RouteAccessRule } from 'src/access/routeAccess'
import { routeAccessAllowed } from 'src/access/routeAccess'
import {
  currentProviderFeatures,
  userRoleSelector,
} from 'src/redux/providers/selectors'

type ProtectedRouteProps = RouteAccessRule & {
  children: React.ReactElement
}

const ProtectedRoute = ({
  children,
  requiredFeatureFlag,
  requiredRole,
}: ProtectedRouteProps) => {
  const userRole = useSelector(userRoleSelector)
  const featureFlags = useSelector(currentProviderFeatures)

  if (
    !routeAccessAllowed(
      { requiredFeatureFlag, requiredRole },
      userRole,
      featureFlags,
    )
  ) {
    // Replacing, not pushing. Pushed, the refused address stayed in history
    // behind the 403, so Back went to it and was sent straight here again:
    // the one way out of the page was a loop.
    return <Navigate to="/403" replace />
  }

  return children
}

export default ProtectedRoute
